import { Box, Divider, Stack } from "@mui/material";

export default function GradientHeader(props) {
	return (
		<Box
			className={props.classes || ""}
			sx={{
				display: "flex",
				flexWrap: "wrap",
				minHeight: "35px",
			}}
		>
			<Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
				{props.children}
			</Stack>

			{props.showDivider && (
				<Divider
					className="!border-disabled"
					textAlign="center"
					orientation="vertical"
					variant="middle"
					flexItem
					style={{ position: "absolute", width: "2px", height: "22px", marginTop: "5px" }}
					sx={props.sxDivider || null}
				/>
			)}
		</Box>
	);
}
